module.exports = __webpack_public_path__ + "img/guanzhu.79502284.png";